// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__2zh0e","generalContainer":"styles_generalContainer__30xpV","containerGrid":"styles_containerGrid__ROI7B","anchor":"styles_anchor__3mRhw"};